import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../../PricingHub/SearchComponent';

class AROpsDetailsSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.startDate',
      name: 'startDate',
      type: 'date',
    },
    {
      label: 'label.endDate',
      name: 'endDate',
      type: 'date',
    },
    {
      label: 'label.arOpsType',
      name: 'arOpsType',
      type: 'select',
      tOptions: 'selections:arOpsType',
      isClearable: true,
    },
    {
      label: 'label.arLevel',
      name: 'arLevel',
      tOptions: 'selections:arLevel',
      isClearable: true,
      type: 'select',
    },
    {
      label: 'label.taxTreatment',
      name: 'taxTreatment',
      type: 'select',
      tOptions: 'selections:taxRule',
      isClearable: true,
    },
    {
      label: 'label.credit_debit',
      name: 'arCrDrType',
      type: 'select',
      tOptions: 'selections:arCrDrType',
      isClearable: true,
    },
    {
      label: 'label.arThreshold',
      name: 'arThreshold',
      type: 'number',
    },
    {
      label: 'label.accountType',
      name: 'accountType',
      type: 'select',
      tOptions: 'selections:accountType',
      isClearable: true,
    },
    {
      label: 'label.organization',
      name: 'company',
    },
    {
      label: 'label.paymentMethod',
      name: 'paymentMethod',
      tOptions: 'selections:paymentMethod',
      isClearable: true,
      type: 'select',
    },
    {
      label: 'label.customReason',
      name: 'customReason',
      type: 'select',
      options: [],
      isClearable: true,
    },
    {
      label: 'label.reason',
      name: 'reason',
      tOptions: 'selections:reasonConfig',
      isClearable: true,
      type: 'select',
    },
    {
      label: 'label.amount',
      name: 'amount',
      type: 'number',
    },
  ];

  btnSpan = 'col-md-9';
}

AROpsDetailsSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

AROpsDetailsSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(AROpsDetailsSearchForm);
